module.exports = __webpack_public_path__ + "media/images/location-bdd3859f88d7adcb98f7698c632908f3.png";